export default __webpack_public_path__ + "static/media/September2022.85cfa219.png";